import './index.css';

import { Dialog as IronDialog } from 'iron-man';
import { debounce } from 'lodash-es';
import { createRoot } from 'react-dom/client';

// 创建容器
const getContainer = () => {
  let el = document.getElementById('aia-bx-dialog');
  if (el === null) {
    el = document.createElement('div');
    document.body.append(el);
    el.id = 'aia-bx-dialog';
  }
  return el;
};
const Dialog = debounce((props) => {
  const { onCancel, onClose, onOk, id = 'bx-system-message' } = props;
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    root.unmount();
  };
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    root.unmount();
  };
  const handleOk = () => {
    if (onOk) {
      onOk();
    }
    root.unmount();
  };

  const root = createRoot(getContainer());

  root.render(
    <div className="bx-message-dialog">
      <IronDialog
        id={id}
        {...props}
        isOpen
        onCancel={handleCancel}
        onClose={handleClose}
        onOk={handleOk}
      />
    </div>
  );
}, 1000);

export default Dialog;
